exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./images/globe.svg"));

// Module
exports.push([module.id, ".widget-editor .maps .widget-icon{background:url(" + ___CSS_LOADER_URL___0___ + ") no-repeat !important;opacity:1 !important}.widget-editor .maps .widget-icon:hover .widget-icon{filter:brightness(0.7)}.widget-editor .maps .widget-icon:active .widget-icon{filter:grayscale(1)}\n", ""]);

